import dayjs from 'dayjs';

import DateInputField from '../common/fields/DateInputField';

function PersonalInfoStep({ formData, setFormData, errors }) {
  return (
    <div className="space-y-4">
      <DateInputField
        label="Date of Birth"
        type="date"
        required
        value={formData.dob}
        minDate={dayjs().subtract(80, 'year')}
        maxDate={dayjs().subtract(18, 'year')}
        onChange={(val) => setFormData({ ...formData, dob: val })}
        error={!!errors?.dob}
        helperText={errors?.dob?.[0]}
      />
    </div>
  );
}

export default PersonalInfoStep;
